const fr = {
  // Navigation
  nav: {
    dashboard: 'Tableau de bord',
    clients: 'Clients',
    articles: 'Articles',
    documents: 'Documents',
    factures: 'Factures',
    devis: 'Devis',
    avoirs: 'Avoirs',
    bonsLivraison: 'Bons de livraison',
    paiements: 'Paiements',
    rapports: 'Rapports',
    rapportTva: 'Déclaration TVA',
    etatAnnuel: 'État annuel',
    parametres: 'Paramètres',
    societe: 'Société',
  },

  // Common
  common: {
    actions: 'Actions',
    add: 'Ajouter',
    edit: 'Modifier',
    delete: 'Supprimer',
    save: 'Enregistrer',
    cancel: 'Annuler',
    search: 'Rechercher',
    filter: 'Filtrer',
    export: 'Exporter',
    print: 'Imprimer',
    close: 'Fermer',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    all: 'Tous',
    active: 'Actif',
    inactive: 'Inactif',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    noResults: 'Aucun résultat',
    page: 'Page',
    of: 'sur',
    rows: 'lignes',
    showing: 'Affichage de',
    to: 'à',
    total: 'Total',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    required: 'Obligatoire',
    optional: 'Optionnel',
    status: 'Statut',
    date: 'Date',
    amount: 'Montant',
    description: 'Description',
    notes: 'Notes',
    code: 'Code',
    designation: 'Désignation',
    reference: 'Référence',
    telephone: 'Téléphone',
    email: 'Email',
    adresse: 'Adresse',
    ville: 'Ville',
    codePostal: 'Code postal',
    createdAt: 'Créé le',
    updatedAt: 'Modifié le',
  },

  // Dashboard
  dashboard: {
    title: 'Tableau de bord',
    caMensuel: 'CA mensuel',
    caAnnuel: 'CA annuel',
    facturesImpayees: 'Factures impayées',
    nombreClients: 'Nombre de clients',
    caMensuel12Mois: 'Chiffre d\'affaires mensuel',
    topClients: 'Top 5 clients par CA',
    dernieresFactures: 'Dernières factures',
    montant: 'Montant',
    client: 'Client',
    nombreFactures: 'Nb factures',
  },

  // Clients
  clients: {
    title: 'Clients',
    newClient: 'Nouveau client',
    editClient: 'Modifier le client',
    raisonSociale: 'Raison sociale',
    matriculeFiscal: 'Matricule fiscal',
    categorie: 'Catégorie',
    contact: 'Contact',
    contactNom: 'Nom du contact',
    mobile: 'Mobile',
    fax: 'Fax',
    rib: 'RIB',
    banque: 'Banque',
    plafondCredit: 'Plafond de crédit',
    delaiPaiement: 'Délai de paiement (jours)',
    exonere: 'Exonéré de TVA',
    tauxRetenueSource: 'Taux retenue à la source (%)',
    actif: 'Client actif',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce client ?',
    matriculeFormat: 'Format: 7 chiffres / lettre / lettre / lettre / 3 chiffres',
  },

  // Articles
  articles: {
    title: 'Articles',
    newArticle: 'Nouvel article',
    editArticle: 'Modifier l\'article',
    prixUnitaireHT: 'Prix unitaire HT',
    tauxTva: 'Taux TVA',
    unite: 'Unité',
    fodec: 'FODEC applicable',
    categorie: 'Catégorie',
    codeBarres: 'Code-barres',
    stockActuel: 'Stock actuel',
    stockMinimum: 'Stock minimum',
    actif: 'Article actif',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet article ?',
  },

  // Documents
  documents: {
    title: 'Documents',
    newDocument: 'Nouveau document',
    editDocument: 'Modifier le document',
    detailDocument: 'Détail du document',
    numero: 'Numéro',
    typeDocument: 'Type de document',
    dateDocument: 'Date du document',
    dateEcheance: 'Date d\'échéance',
    client: 'Client',
    selectClient: 'Sélectionner un client',
    selectArticle: 'Sélectionner un article',
    lignes: 'Lignes du document',
    addLine: 'Ajouter une ligne',
    removeLine: 'Supprimer la ligne',
    article: 'Article',
    quantite: 'Quantité',
    prixUnitaire: 'Prix unitaire',
    remise: 'Remise (%)',
    montantHT: 'Montant HT',
    montantFodec: 'FODEC',
    montantTva: 'Montant TVA',
    tauxTva: 'Taux TVA',
    remiseTotale: 'Remise totale',
    totalHT: 'Total HT',
    totalTva: 'Total TVA',
    totalFodec: 'Total FODEC',
    timbreFiscal: 'Timbre fiscal',
    timbreFiscalToggle: 'Appliquer le timbre fiscal',
    timbreFiscalNonApplique: 'Non appliqué',
    totalTTC: 'Total TTC',
    retenueSource: 'Retenue à la source',
    netAPayer: 'Net à payer',
    modePaiement: 'Mode de paiement',
    statutPaiement: 'Statut de paiement',
    montantPaye: 'Montant payé',
    resteAPayer: 'Reste à payer',
    referenceExterne: 'Référence externe',
    convertToFacture: 'Convertir en facture',
    convertConfirm: 'Voulez-vous convertir ce devis en facture ?',
    recordPayment: 'Enregistrer un paiement',
    paymentHistory: 'Historique des paiements',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce document ?',
    printDocument: 'Imprimer le document',
    eInvoiceToggle: 'Facturation électronique (El Fatoora / TTN)',
    eInvoiceToggleHint: "Générer et transmettre la facture au format TEIF à la plateforme Tunisie TradeNet. La signature qualifiée ANCE sera apposée avant envoi.",
    timbreFiscalToggleHint: "Décochez pour les opérations exonérées (export, client non résident, franchise). Le timbre n'est alors ni ajouté au net à payer ni imprimé sur le PDF.",
    eInvoiceTitle: 'Facture électronique — El Fatoora',
    eInvoiceSubtitle: 'Génération XML TEIF et transmission à la plateforme TTN.',
    eInvoiceReference: 'Référence TTN',
    eInvoiceTransmittedAt: 'Transmise le',
    eInvoiceMessage: 'Message TTN',
    eInvoiceGenerate: 'Générer le XML TEIF',
    eInvoiceSubmit: 'Transmettre à TTN',
    eInvoiceShowXml: 'Voir le XML',
    eInvoiceHideXml: 'Masquer le XML',
    eInvoiceGenerated: 'XML TEIF généré.',
    eInvoiceSubmitted: 'Transmis à TTN.',
    eInvoiceError: 'Erreur lors de l\'opération TTN.',
    eInvoiceStatuts: {
      BROUILLON: 'Brouillon',
      GENEREE: 'XML généré',
      TRANSMISE: 'Transmise',
      ACCEPTEE: 'Acceptée par TTN',
      REJETEE: 'Rejetée par TTN',
    },
  },

  // Paiements
  paiements: {
    title: 'Paiements',
    newPaiement: 'Nouveau paiement',
    datePaiement: 'Date du paiement',
    montant: 'Montant',
    modePaiement: 'Mode de paiement',
    reference: 'Référence',
    banque: 'Banque',
    dateEcheance: 'Date d\'échéance',
    document: 'Document',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce paiement ?',
  },

  // Rapports
  rapports: {
    title: 'Rapports',
    tva: {
      title: 'Déclaration de TVA',
      periode: 'Période',
      mois: 'Mois',
      annee: 'Année',
      generer: 'Générer',
      baseHT: 'Base HT',
      tvaCollectee: 'TVA collectée',
      tva7: 'TVA 7%',
      tva13: 'TVA 13%',
      tva19: 'TVA 19%',
      totalTva: 'Total TVA',
      fodec: 'FODEC',
      timbre: 'Droit de timbre',
    },
    annuel: {
      title: 'État annuel',
      annee: 'Année',
      caTotal: 'CA total',
      tvaCollectee: 'TVA collectée',
      nombreFactures: 'Nombre de factures',
      nombreDevis: 'Nombre de devis',
      nombreAvoirs: 'Nombre d\'avoirs',
      repartitionTva: 'Répartition par taux de TVA',
      evolutionCA: 'Évolution du CA',
    },
  },

  // Paramètres
  parametres: {
    title: 'Paramètres',
    societe: {
      title: 'Paramètres de la société',
      raisonSociale: 'Raison sociale',
      matriculeFiscal: 'Matricule fiscal',
      adresse: 'Adresse',
      codePostal: 'Code postal',
      ville: 'Ville',
      telephone: 'Téléphone',
      email: 'Email',
      siteWeb: 'Site web',
      rib: 'RIB bancaire',
      banque: 'Banque',
      logo: 'Logo',
      uploadLogo: 'Télécharger le logo',
      timbreFiscal: 'Montant timbre fiscal (TND)',
      tauxFodec: 'Taux FODEC (%)',
    },
  },

  // Validation messages
  validation: {
    required: 'Ce champ est obligatoire',
    email: 'Adresse email invalide',
    phone: 'Numéro de téléphone invalide',
    matriculeFiscal: 'Matricule fiscal invalide (format: 1234567/A/B/C/123)',
    rib: 'RIB invalide (20 chiffres)',
    codePostal: 'Code postal invalide (4 chiffres)',
    positiveNumber: 'La valeur doit être positive',
    minLength: 'Minimum {min} caractères',
  },

  // Messages
  messages: {
    saveSuccess: 'Enregistrement effectué avec succès',
    saveError: 'Erreur lors de l\'enregistrement',
    deleteSuccess: 'Suppression effectuée avec succès',
    deleteError: 'Erreur lors de la suppression',
    loadError: 'Erreur lors du chargement des données',
    convertSuccess: 'Devis converti en facture avec succès',
    paymentSuccess: 'Paiement enregistré avec succès',
    confirmDelete: 'Confirmer la suppression',
    confirmDeleteMessage: 'Cette action est irréversible. Voulez-vous continuer ?',
  },

  // Months
  months: [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre',
  ],

  // Admin (platform administration console)
  admin: {
    console: 'Admin',
    logout: 'Se déconnecter',
    nav: {
      dashboard: 'Tableau de bord',
      subscribers: 'Abonnés',
      invoices: 'Factures SaaS',
      metrics: 'Métriques',
      aiModels: 'Modèles IA',
      ops: 'Ops',
    },
    dashboard: {
      title: 'Tableau de bord administration',
      subtitle: "Vue d'ensemble de la plateforme GreenBill.",
      totalSubscribers: 'Abonnés actifs',
      mrr: 'Revenu mensuel récurrent',
      pendingInvoices: 'Factures en attente',
      planChanges: 'Changements de plan (30 j)',
      byPlan: 'Répartition par plan',
      viewAll: 'Voir tous les abonnés →',
    },
    subscribers: {
      title: 'Abonnés',
      searchPlaceholder: 'Raison sociale, matricule fiscal, email…',
      allPlans: 'Tous les plans',
      col: {
        name: 'Raison sociale',
        mf: 'Matricule fiscal',
        plan: 'Plan',
        invoicesMonth: 'Factures (mois)',
        users: 'Utilisateurs',
        createdAt: 'Inscrit le',
      },
    },
    subscriberDetail: {
      back: 'Retour à la liste',
      createdAt: 'Inscrit le',
      plan: 'Plan actuel',
      users: 'utilisateur(s)',
      reasonPrompt: 'Raison du changement de plan ?',
      planUpdated: 'Plan mis à jour',
      usageTitle: 'Utilisation',
      invoicesTitle: 'Factures SaaS',
      noInvoices: 'Aucune facture SaaS pour cet abonné.',
      period: 'Période',
      amount: 'Montant TTC',
    },
    usage: {
      invoices: 'Factures créées',
      ocr: 'Pages OCR',
      api: 'Appels API',
      seats: 'Sièges utilisateurs',
      documents: 'Documents (autres)',
    },
    invoices: {
      title: 'Factures SaaS',
      allStatuses: 'Tous les statuts',
      runBilling: 'Lancer la facturation du mois',
      runConfirm: 'Générer les factures SaaS pour le mois en cours ?',
      invoicesCreated: 'factures générées',
      openLink: 'Ouvrir',
      col: {
        company: 'Abonné',
        period: 'Période',
        amount: 'TTC',
        payment: 'Lien paiement',
      },
    },
    metrics: {
      title: 'Métriques SaaS',
      mrr: 'MRR (TND)',
      arr: 'ARR (TND)',
      totalSubscribers: 'Abonnés actifs',
      byPlan: 'Abonnés par plan',
      paidThisMonth: 'Factures payées',
      pendingThisMonth: 'Factures en attente',
      planChanges: 'Changements de plan (30 j)',
    },
    ops: {
      title: 'Ops',
      subtitle: 'Logs serveur, état du système et tâches planifiées.',
      tabs: {
        logs: 'Console',
        system: 'Système',
        health: 'Santé',
        gts: 'Green Target',
        jobs: 'Tâches',
      },
      logs: {
        title: 'Console serveur',
        level: 'Niveau',
        allLevels: 'Tous les niveaux',
        search: 'Rechercher dans les logs…',
        lines: 'Lignes',
        autoRefresh: 'Rafraîchissement auto',
        refresh: 'Rafraîchir',
        download: 'Télécharger',
        empty: 'Aucune ligne de log.',
        unavailable: 'Fichier de log introuvable sur le serveur.',
        returned: 'lignes',
      },
      system: {
        title: 'Système',
        appName: 'Application',
        profiles: 'Profils actifs',
        uptime: 'Temps de fonctionnement',
        startedAt: 'Démarré le',
        java: 'Version Java',
        os: "Système d'exploitation",
        processors: 'Processeurs',
        threads: 'Threads',
        heap: 'Mémoire (heap)',
      },
      health: {
        title: 'Santé',
        status: 'État global',
        components: 'Composants',
      },
      gts: {
        title: 'Green Target',
        verdictOk: 'Synchronisation opérationnelle avec Green Target',
        verdictWarn: 'Configuré, mais attention requise',
        verdictKo: 'Non configuré ou injoignable',
        refresh: 'Rafraîchir',
        sync: 'Synchroniser',
        syncing: 'Synchronisation…',
        syncDone: 'Synchronisation effectuée',
        backfilledLabel: 'ajoutées',
        publishedNowLabel: 'publiées',
        syncDisabledHint: 'Pont REST désactivé',
        configTitle: 'Configuration',
        bridgeEnabled: 'Pont REST activé',
        ssoConfigured: 'Secret SSO partagé configuré',
        kafkaEnabled: 'Transport Kafka',
        gtsBaseUrl: 'URL API GTS',
        gtsSsoBaseUrl: 'URL SSO GTS',
        connTitle: 'Connectivité',
        reachable: 'GTS joignable',
        latency: 'Latence',
        httpStatus: 'Statut HTTP',
        syncTitle: 'File de synchronisation (outbox)',
        pending: 'En attente',
        published: 'Publiés',
        failed: 'Échecs',
        lastPublished: 'Dernière synchro réussie',
        oldestPending: 'Plus ancien événement en attente',
        yes: 'Oui',
        no: 'Non',
        active: 'Actif',
        off: 'Désactivé',
        never: 'Jamais',
      },
      jobs: {
        title: 'Tâches planifiées',
        schedule: 'Planification',
        nextRun: 'Prochaine exécution',
        enabled: 'Activée',
        disabled: 'Désactivée',
        run: 'Exécuter',
        running: 'En cours…',
        triggered: 'Tâche lancée',
        confirm: 'Exécuter cette tâche maintenant ?',
      },
    },
    aiModels: {
      title: 'Modèles IA',
      subtitle:
        'Modifiez le fournisseur et le modèle utilisés par chaque fonctionnalité IA. Testez avant d’enregistrer.',
      refresh: 'Rafraîchir',
      disabledWarning:
        'L’IA est désactivée globalement (app.llm.enabled=false). Les modifications sont enregistrées mais non utilisées tant que l’IA n’est pas réactivée.',
      notConfigured: 'non configuré',
      provider: 'Fournisseur',
      model: 'Modèle',
      temperature: 'Température',
      maxTokens: 'Tokens max',
      jsonMode: 'Mode JSON',
      test: 'Tester',
      testing: 'Test en cours…',
      testOk: 'Test réussi',
      testFailed: 'Échec du test',
      testFirst: 'Testez avec succès avant d’enregistrer',
      save: 'Enregistrer',
      saving: 'Enregistrement…',
      saved: 'Modèle enregistré',
      unsaved: 'Non enregistré',
      modelRequired: 'Le modèle est requis.',
      loadingModels: 'Chargement des modèles…',
      noModels: 'Aucun modèle disponible. Saisissez un identifiant manuellement.',
      noMatch: 'Aucun modèle ne correspond.',
      moreModels: 'Affinez votre recherche pour voir plus de modèles…',
      free: 'Gratuit',
      vision: 'vision',
      tokens: 'tokens',
      priceLabel: 'Prix (in/out par 1M tokens)',
      priceHint: 'Prix indiqués en USD par 1M tokens (entrée / sortie).',
      features: {
        OCR: 'OCR (lecture de factures)',
        RELANCE_EMAIL: 'Relances par email',
        DASHBOARD_ASSISTANT: 'Assistant tableau de bord',
      },
    },
  },
};

export default fr;
